import { render, staticRenderFns } from "./waishuirecord.vue?vue&type=template&id=0c04c30c"
import script from "./waishuirecord.vue?vue&type=script&lang=js"
export * from "./waishuirecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports